var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?[_c('Load'),_c('div',{staticClass:"full-h-screen"})]:[_c('OrderDetailStudio7',{on:{"fetch":_vm.getData},scopedSlots:_vm._u([{key:"appendOrderDetail",fn:function(){return [(_vm.isBarcode)?_c('div',[_c('img',{attrs:{"src":_vm.barcode,"width":"256","height":"40"}})]):_vm._e()]},proxy:true}])})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }